export const AlertTriangleSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_7977_30847)">
      <path
        d="M6.90898 2.39429L1.50498 11.417C1.39358 11.6099 1.33463 11.8286 1.33399 12.0514C1.33335 12.2742 1.39105 12.4932 1.50135 12.6868C1.61164 12.8803 1.77069 13.0416 1.96268 13.1547C2.15466 13.2677 2.37289 13.3285 2.59565 13.331H13.405C13.6276 13.3284 13.8458 13.2676 14.0377 13.1546C14.2295 13.0416 14.3885 12.8804 14.4988 12.6869C14.6091 12.4935 14.6668 12.2745 14.6663 12.0519C14.6657 11.8292 14.6069 11.6105 14.4956 11.4176L9.09165 2.39362C8.97795 2.20596 8.81778 2.05078 8.62662 1.94309C8.43545 1.83539 8.21973 1.77881 8.00032 1.77881C7.7809 1.77881 7.56519 1.83539 7.37402 1.94309C7.18285 2.05078 7.02268 2.20596 6.90898 2.39362V2.39429Z"
        fill="#E8BE3C"
        stroke="#E8BE3C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 6V8.66667"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.6667H8.00667"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7977_30847">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
